import {Link} from "react-router-dom";

export default function NsMenuStart() {

    return (
        <div className={"ns-logo-start-container"}>
            <Link to="/home-container">
                <img src={"YEP-logo-negativo.svg"} className={"ns-logo-icon"} alt="YEP Logo"/>
            </Link>
        </div>
    );
}